export const userTypes = [
    'אינו מדריך',
    'חבר ועד מנהל',
    'חבר מועצה',
    'יוצר ריקודי עם',
    'יקיר',
    'כוריאוגרף לבמה',
    'מדריך',
    'מדריך פעיל',
    'מדריכי חו"ל',
    'מדריך ילדים',
    'מדריך אוכלוסיות מיוחדות',
]

export const orders = [...Array(10).keys()]
